export const areas = [
    {
        id: 'logistica',
        concepto: 'conceptoLogistica',
        costo: 'valorLogistica',
        responsable: 'cedulaLogistica',
        name: 'Logistica',
        ok: 'aprobacionLogistica',
        estado_editable: 'PENDIENTE_APROBACION'
    },
    {
        id: 'it',
        concepto: 'conceptoIT',
        costo: 'valorIT',
        responsable: 'cedulaIT',
        name: 'IT',
        ok: 'aprobacionIT',
        estado_editable: 'PENDIENTE_APROBACION'
    },
    {
        id: 'contabilidad',
        concepto: 'conceptoContabilidad',
        costo: 'valorContabilidad',
        responsable: 'cedulaContabilidad',
        name: 'Contabilidad',
        ok: 'aprobacionContabilidad',
        estado_editable: 'PENDIENTE_APROBACION'
    },
    {
        id: 'tesoreria',
        concepto: 'conceptoTesoreria',
        costo: 'valorTesoreria',
        responsable: 'cedulaTesoreria',
        name: 'Tesoreria',
        ok: 'aprobacionTesoreria',
        estado_editable: 'PENDIENTE_APROBACION'
    },
    {
        id: 'hseq',
        concepto: 'conceptoHSEQ',
        costo: 'valorHSEQ',
        responsable: 'cedulaHSEQ',
        name: 'HSEQ',
        ok: 'aprobacionHSEQ',
        estado_editable: 'PENDIENTE_APROBACION'
    },
    {
        id: 'capacitacion',
        concepto: 'conceptoCapacitacion',
        costo: 'valorCapacitaciones',
        responsable: 'cedulaCapacitaciones',
        name: 'Capacitacion',
        ok: 'aprobacionCapacitacion',
        estado_editable: 'PENDIENTE_APROBACION'
    },
    {
        id: 'jefe',
        concepto: 'conceptoJefe',
        costo: 'valorJefe',
        responsable: 'cedulaJefe',
        name: 'Jefe',
        ok: 'aprobacionJefe',
        estado_editable: 'PENDIENTE_APROBACION'
    }];

export const areasSegFase = [
    {
        id: 'administrativo',
        estado_editable: 'VERIFICACION_ADMINISTRATIVO',
        name:'Verificción Área Administrativa',
        adjuntos:[
            {
                key: 'sobretiempos',
                name: 'Sobretiempos'
            },
            {
                key: 'sobretiempos2',
                name: 'Sobretiempos'
            }
        ]
    },
    {
        id: 'contratacion',
        estado_editable: 'VERIFICACION_CONTRATACION',
        name:'Verificción Área Contratacíon',
        adjuntos:[
            {
                key: 'novedades',
                name: 'Novedades'
            }
        ]
    },
    {
        id: 'nomina',
        estado_editable: 'VERIFICACION_NOMINA',
        name:'Verificción Nomina',
        adjuntos:[
            {
                key: 'nomina',
                name: 'Nomina'
            }
        ]
    },]